import { ModulesMap, ModulesConfigMap } from '../data/modulesMaps'

export default {
	getTrips: {
		apiServiceMethodName:
			ModulesConfigMap[ModulesMap.TRIPS].GET_TRIPS,
	},
  getTrip: {
		apiServiceMethodName:
			ModulesConfigMap[ModulesMap.TRIPS].GET_TRIP,
	},
  getTripsPopup: {
		apiServiceMethodName:
			ModulesConfigMap[ModulesMap.TRIPS].GET_TRIPS_POPUP,
	},
	getTripsPreview: {
		apiServiceMethodName:
			ModulesConfigMap[ModulesMap.TRIPS].GET_TRIPS_PREVIEW,
	}
}
